module.exports = __webpack_public_path__ + "img/BNI-SmallCorner.d848bcc1.png";